import IconButton from '@gogame/ui/IconButton';

import LegacyBox from '../../../../_legacyComponents/Box/index';
import LegacyText from '../../../../_legacyComponents/Text/index';
import styled from '../../../../styled';

export const ActionButton = styled(IconButton)`
  display: none;
`;
export const CrossedActionButton = styled(IconButton)`
  &:before,
  &:after {
    content: '';
    width: 2px;
    height: 26px;
    position: absolute;
    transform: rotate(-45deg);
  }
  &:before {
    top: 2px;
    left: 10px;
    background: ${(props) => props.theme.palette.text.primary})
  }
  &:after {
    top: 3px;
    left: 13px;
    background: ${(props) => props.theme.palette.text.primary});
  }
  &:hover:after {
    background: ${(props) => props.theme.palette.text.primary});
  }
`;

export const MarkerIcon = styled('svg')`
  fill: ${(props) =>
    props.hidden ? props.theme.palette.action.disabled : props.color};
`;

export const IconWrapper = styled(LegacyBox)`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 24px;
`;

export const Title = styled(LegacyText)`
  line-height: 1.2;
  word-break: break-all;
  color: ${(props) =>
    props.hidden
      ? props.theme.palette.text.disabled
      : props.theme.palette.text.primary};

  &::before {
    display: block;
    content: attr(title);
    font-weight: bold;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export const LegendItem = styled(LegacyBox)`
  margin-bottom: 4px;
  margin-right: 8px;
  max-width: 200px;
  &:hover {
    ${ActionButton} {
      display: flex;
    }

    ${MarkerIcon} {
      display: none;
    }

    ${Title} {
      text-shadow: 0 0 0.1px ${(props) => props.theme.palette.text.primary};
    }
  }
`;
